import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valeurMonetaireFr'
})
export class ValeurMonetaireFrPipe implements PipeTransform {

  transform(value: number): string {
    const formatter = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
    });
    return formatter.format(value)
  }
}
